import { SalesSites } from './sales-sites.component.js';

export * from './sales-sites.component.js';
export default SalesSites;

SalesSites.define('der-tailormade-appointment-booking-sales-sites');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking-sales-sites': SalesSites;
    }
}
